/**
 * One read of GET /attendance/overtime-policy/me/ per browser session when
 * the answer cannot change: no employee record, no overtime policy, or a
 * client status that means "nothing to show". Eligible callers are not
 * cached, because the approach banner has to see an open shift move.
 */
import { api } from './api';

const TERMINAL_STATUSES = new Set([400, 403, 404]);

let cached = null;
let inflight = null;

function sessionToken() {
  try {
    return sessionStorage.getItem('access_token') || '';
  } catch {
    return '';
  }
}

export function resetOvertimePolicySessionCache() {
  cached = null;
  inflight = null;
}

function rememberTerminal(token, data) {
  cached = { token, data };
  return data;
}

export function fetchMyOvertimePolicy() {
  const token = sessionToken();
  if (cached && cached.token === token) {
    return Promise.resolve(cached.data);
  }
  if (inflight && inflight.token === token) {
    return inflight.promise;
  }

  const promise = api.get('/attendance/overtime-policy/me/')
    .then((response) => {
      const empty = response.status === 204
        || response.data == null
        || response.data === '';
      const data = empty
        ? { eligible: false, has_employee_record: false }
        : response.data;
      if (!data || data.eligible !== true) {
        const terminal = data && typeof data === 'object'
          ? data
          : { eligible: false, has_employee_record: false };
        return rememberTerminal(token, terminal);
      }
      return data;
    })
    .catch((error) => {
      const status = error?.response?.status;
      if (TERMINAL_STATUSES.has(status)) {
        return rememberTerminal(token, {
          eligible: false,
          has_employee_record: false,
        });
      }
      throw error;
    })
    .finally(() => {
      if (inflight && inflight.promise === promise) inflight = null;
    });

  inflight = { token, promise };
  return promise;
}
